import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'form.formHeader.configurationModal.title',
    defaultMessage: 'Configuration',
  },
  validateLabel: {
    id: 'form.formHeader.configurationModal.validateLabel',
    defaultMessage: 'API URL',
  },
  validatePlaceholder: {
    id: 'form.formHeader.configurationModal.validatePlaceholder',
    defaultMessage: 'https://your-domain.com/api/validate',
  },
  cancel: {
    id: 'form.formHeader.configurationModal.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'form.formHeader.configurationModal.save',
    defaultMessage: 'Save',
  },
  invalidUrl: {
    id: 'form.formHeader.configurationModal.invalidUrl',
    defaultMessage: 'Please enter a valid URL (e.g., https://your-domain.com/api/validate).',
  },
  maxLength: {
    id: 'form.formHeader.configurationModal.maxLength',
    defaultMessage: 'URL cannot exceed 2000 characters.',
  },
});
